import i18next from "i18next";
import { lazy } from "react";
import { getExactRoute } from "util/react";

import EN from "./i18n/en.json";
import LT from "./i18n/lt.json";

i18next.addResourceBundle("en", "activityLog", EN);
i18next.addResourceBundle("lt", "activityLog", LT);

export const URIS = {
  LIST: "/activity-log",
};

export const ActivityLogListRoute = getExactRoute(
  "activityLog",
  "menu.main",
  URIS.LIST,
  lazy(() => import("./layout/ActivityLogListLayout")),
  null,
  ["admin"],
);

const ActivityLogRoute = <>{ActivityLogListRoute}</>;

export default ActivityLogRoute;
